import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { toast, ToastContainer } from "react-toastify";
// import 'react-toastify/dist/ReactToastify.css';
// import { useNavigate } from "react-router";
// import ProfilePic from "../../components/Common/SvgIcons/HeaderIcons/ProfilePic";
import BoxShadowIcon from "../../components/Common/SvgIcons/HeaderIcons/BoxShadowIcon";
import profileImg from "../../assets/images/Common/profileImg.svg";
// import Input from "../../components/Common/ReactForm/Input/Input";
import Input from "../../components/Common/Input/Input";
import DeleteIcon from "../../components/Common/SvgIcons/HeaderIcons/DeleteIcon";
import EmailIcon from "../../components/Common/SvgIcons/HeaderIcons/EmailIcon";
import OrganizationIcon from "../../components/Common/SvgIcons/HeaderIcons/OrganizationIcon";
import {
  updateMyProfileActionHandler,
  getMyProfileActionHandler,
} from "../../store/actions/actionHandlers/commonActionHandler";
import { DEFAULT_PROFILE_IMAGE } from "../../utils/otherConstanst";
import { FaCamera } from "react-icons/fa";
import { setErrorHandler } from "../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../utils/errorTypes";
import { useForm, FormProvider } from "react-hook-form";
import classes from "./MyProfilePage.module.scss";
import {
  getUserGroupByUserIdActionHandler,
  putMyProfileActionHandler,
} from "../../store/actions/actionHandlers/headerActionHandler";
import Button from "../../components/Common/Button/Button";
import CrossIcon from "../../components/Common/SvgIcons/SocialIcons/CrossIcon";
import EditIcon from "../../components/Common/SvgIcons/TableIcons/EditIcon";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Loader from "../../components/Common/Loader/Loader";
import { FormattedMessage } from "react-intl";

export const myProfileSchema = yup.object().shape({
  profileMailID: yup.string().required("Please enter email ID"),
});

const MyProfilePage = () => {
  const { FAIL } = errorTypes;
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const chooseFromGallery = React.useRef(null);
  const [hoverImageIcon, setHoverImageIcon] = useState(false);
  const [userGroup, setUserGroup] = useState(null);
  const [groupLoader, setGroupLoader] = useState(false);
  const [editEmailLoader, setEditEmailLoader] = useState(false);
  const tenantName = localStorage.getItem("tenantName");
  const userName = localStorage.getItem("userName");
  const commonState = useSelector((state) => state.commonReducer);
  const { myProfile, colors } = commonState;

  useEffect(() => {
    dispatch(getMyProfileActionHandler());
  }, [dispatch]);

  useEffect(() => {
    if (myProfile?.LoginId) {
      dispatch(
        getUserGroupByUserIdActionHandler(
          myProfile?.LoginId,
          setUserGroup,
          setGroupLoader
        )
      );
    }
  }, [dispatch, myProfile?.LoginId]);

  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(myProfileSchema),
  });
  const {
    handleSubmit,
    formState: { errors, isValid },
    setValue,
  } = methods;

  const handleDelete = (e) => {
    e.preventDefault();
    let userProfile = {};
    userProfile.ID = myProfile.ID;
    userProfile.ContentType = ".JPG";
    userProfile.ImageData = DEFAULT_PROFILE_IMAGE;
    dispatch(updateMyProfileActionHandler(userProfile));
    // dispatch(setErrorHandler(SUCCESS, "Profile Picture removed"));
  };
  const handleOpen = () => {
    chooseFromGallery.current.click();
  };
  const handleImageChange = (e) => {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];
    if (
      file !== undefined &&
      (file.type === "image/png" ||
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/bmp")
    ) {
      reader.onloadend = () => {
        var base64image = reader.result.slice(
          reader.result.indexOf(",") + 1,
          reader.result.length
        );
        let userProfile = {};
        userProfile.ContentType = file.type;
        userProfile.ImageData = base64image;
        userProfile.ID = myProfile.ID;
        dispatch(updateMyProfileActionHandler(userProfile));
      };
      reader.readAsDataURL(file);
    } else {
      dispatch(setErrorHandler(FAIL, "Unsupported Media Type"));
    }
  };
  // console.log(myProfile?.ProfileImageUrl)

  // const notify = () => toast("Wow so easy!");
  // const val = watch("ProfileImg", false);
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState();
  const [validEmailAddress, setValidEmailAddress] = useState(false);
  const [error, setError] = useState(false);
  const isValidEmail = (email) => {
    return /\S+@\S+\.\S\S+/.test(email);
  };
  const handleEmailValidation = (e) => {
    // debugger;
    setEmail(e.target.value);
  };
  const onSubmit = (data, e) => {
    setEmail(data.profileMailID);
    let postData = {
      isPswdChanged: false,
      tenantName: tenantName,
      isCustomLogin: true,
    };
    let payloadData = {
      ...myProfile,
      EmailId: data.profileMailID,
      OldEmailId: myProfile?.EmailId,
    };
    if (error) {
      dispatch(setErrorHandler(errorTypes.FAIL, "Please enter valid Email ID"));
    } else {
      if (data?.profileMailID == myProfile?.EmailId) {
        dispatch(setErrorHandler(errorTypes.WARN, "Please enter New Email ID"));
      } else {
        dispatch(
          putMyProfileActionHandler(postData, payloadData, setEditEmailLoader)
        ).then((response) => {
          if (response) {
            setOpen(false);
            dispatch(getMyProfileActionHandler());
            dispatch(
              getUserGroupByUserIdActionHandler(
                myProfile?.LoginId,
                setUserGroup
              )
            );
            setEditEmailLoader(false);
            dispatch(
              setErrorHandler(
                errorTypes.SUCCESS,
                "User Profile Changed Successfully"
              )
            );
          }
        });
      }
    }
  };
  useEffect(() => {
    setError(false);
    if (isValidEmail(email)) {
      setError(false);
    } else {
      setError(true);
    }
  }, [email, onSubmit]);
  const handleEditBtn = () => {
    setValue("profileMailID", myProfile?.EmailId);
    setEmail(myProfile.EmailId);
    setOpen(!open);
  };
  const handleCancleBtn = () => {
    setOpen(false);
  };

  return groupLoader ? (
    <Loader page />
  ) : (
    <div className={classes.myProfilePage}>
      <div className={classes.myProfileDetails}>
        <div className={classes.myProfileDetails__profileIcon}>
          <div
            className={classes.myProfileDetails__profileIcon__onHover}
            onMouseEnter={() => {
              setHoverImageIcon(true);
            }}
            onMouseLeave={() => {
              setHoverImageIcon(false);
            }}
          >
            {/* <ProfilePic width={"22.3rem"} height={"22.3rem"} /> */}
            <img
              src={
                myProfile?.ProfileImageUrl === "Profil" ||
                myProfile?.ProfileImageUrl === "" ||
                myProfile?.ProfileImageUrl === null
                  ? profileImg
                  : myProfile?.ProfileImageUrl
              }
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = profileImg;
              }}
              alt="profile"
            />
            <FormProvider {...methods}>
              <Input
                reference={chooseFromGallery}
                type={"file"}
                name={"ProfileImg"}
                onChange={handleImageChange}
                accept=".jpeg,.png,.bmp,.jpg"
                hidden
                fileInputName={"false"}
                fileInputButton={false}
              />
            </FormProvider>
            {/* <input
              ref={chooseFromGallery}
              type="file"
              onChange={(e) => handleImageChange(e)}
              accept=".jpeg,.png,.bmp,.jpg"
              style={{ visibility: "hidden" }}
            /> */}
            {hoverImageIcon && (
              <div
                className={
                  classes.myProfileDetails__profileIcon__chooseFromGallery
                }
                onClick={handleOpen}
              >
                <div>
                  <FaCamera />
                </div>
                <div>Choose From Gallery</div>
              </div>
            )}
          </div>
          <div className={classes.myProfileDetails__profileIcon__boxShadowIcon}>
            <BoxShadowIcon />
          </div>
          <div
            className={classes.myProfileDetails__profileIcon__deleteIcon}
            onClick={handleDelete}
          >
            <DeleteIcon />
          </div>
          {/* <div
            className={classes.myProfileDetails__profileIcon__UploadProfilePic}
          >
            <Input
              type={"file"}
              height={"100%"}
              ref={chooseFromGallery}
              onChange={(e) => handleImageChange(e)}
            />
          </div> */}
        </div>
        <div className={classes.userProfileDetail}>
          <h1>
            <FormattedMessage id="MY_PROFILE_ABOUTME_TEXT" />
          </h1>
          <div className={classes.userProfileDetail__userName}>
            {myProfile?.FirstName + " " + myProfile?.LastName}
          </div>
          <div
            className={`${classes.userProfileDetail__userEmailId} ${classes.userProfileDetail__sameCss}`}
          >
            <span>
              <FormattedMessage id="MY_PROFILE_USERID_TEXT" /> :
            </span>{" "}
            {myProfile?.LoginId}
          </div>
          <div
            className={`${classes.userProfileDetail__userOrgId} ${classes.userProfileDetail__sameCss}`}
          >
            {/* <OrganizationIcon /> */}
            <span>
              <FormattedMessage id="MY_PROFILE_ORGNAME_TEXT" /> :
            </span>{" "}
            {tenantName}
          </div>
          {myProfile?.Store?.length > 0 && (
            <div
              className={`${classes.userProfileDetail__userOrgId} ${classes.userProfileDetail__sameCss} myProfile?.Store?.length > 0 && ${classes.officeLocationsMain}`}
            >
              <span>
                <FormattedMessage id="REPORT_ENTERLOCATION_TXT" />:
              </span>
              <div className={classes.officeLocationsBody}>
                {myProfile?.Store?.map((item) => {
                  return (
                    <div className={classes.officeLocations}>
                      {item.Address}
                      {", "} {item.CityName}
                      {", "}
                      {item.StateName}
                      {", "} {item.CountryName}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div
                className={`${classes.userProfileDetail__userOrgId} ${classes.userProfileDetail__sameCss}`}
              >
                <span>
                  <FormattedMessage id="USERMANAGE_EMAILID" />:
                </span>
                <div className={classes.profileMailID}>
                  {!open && myProfile?.EmailId}
                  {open && (
                    <div style={{ position: "relative" }}>
                      <Input
                        name="profileMailID"
                        placeholder={"Enter Email ID"}
                        error={errors?.profileMailID?.message}
                        required
                        onChange={handleEmailValidation}
                        width="23"
                        style={{
                          minHeight: "0",
                          borderRadius: "0.4rem",
                          padding: 0.3 + "rem",
                        }}
                      />
                      {errors?.profileMailID?.message ? (
                        <div className={classes.validEmailCheck}>
                          {errors.Name?.message}
                        </div>
                      ) : error ? (
                        <div className={classes.validEmailCheck}>
                          Please enter valid Email ID
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  )}
                  {open && (
                    <span
                      className={classes.cancleBtn}
                      onClick={handleCancleBtn}
                      style={{ marginTop: "1rem" }}
                    >
                      <CrossIcon fill={colors?.theme} />{" "}
                      <FormattedMessage id="USERMANAGE_CANCEL" />
                    </span>
                  )}
                  <span style={{ marginTop: open ? "1rem" : "0rem" }}>
                    {!open && (
                      <Button
                        dark
                        label={<FormattedMessage id="USERMANAGE_BTNEDIT" />}
                        onClick={handleEditBtn}
                        height="2.7"
                        width="8"
                        borderRadius="0.4"
                      />
                    )}
                    {open && (
                      <Button
                        dark
                        label={<FormattedMessage id="USERMANAGE_BTNSAVE" />}
                        height="2.7"
                        width="8"
                        type={"submit"}
                        borderRadius="0.4"
                        disabled={!isValid}
                        loading={editEmailLoader}
                      />
                    )}
                  </span>
                </div>
              </div>
            </form>
          </FormProvider>

          {myProfile?.Category?.length > 0 && (
            <div
              className={`${classes.userProfileDetail__userOrgId} ${classes.userProfileDetail__sameCss}`}
            >
              <span>
                <FormattedMessage id="USERMANAGE_PRODUCTCATEGORY" />:
              </span>{" "}
              {myProfile?.Category.map(
                (item, index) => (index ? ", " : "") + item.Name
              )}
            </div>
          )}
          {userGroup?.TotalLength > 0 && (
            <div
              className={`${classes.userProfileDetail__userOrgId} ${classes.userProfileDetail__sameCss}`}
            >
              <span>
                <FormattedMessage id="MY_PROFILE_USERGROUP_TEXT" />:
              </span>{" "}
              {userGroup?.UserGroups?.map(
                (item, index) => (index ? ", " : "") + item.Name
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyProfilePage;
